export default __webpack_public_path__ + "static/media/tenstbetterltable.92f12270.webp";